import axios from 'axios'
import { ApiConfig } from '../config/ApiConfig'
const axiosClient = axios.create()

// Intercept request
axiosClient.interceptors.request.use(
	(request) => {
		request.headers['Content-Type'] = 'application/json'
		return request
	},
	null,
	{ synchronous: true }
)

// Intercept response
axiosClient.interceptors.response.use(
	(response) =>{
		// Dispatch any action on success
		//if(response?.status === responseCodes.SUCCESS200)
		return response?.data
	}
	,
	(error) => {
		
			return Promise.reject(error.response.data)
		
	}
)

// 

// axiosClient.defaults.baseURL ="";

axiosClient.defaults.headers = {
	'Content-Type': 'application/json, charset=UTF-8',
	Accept: 'application/json, text/plain, */*',
	'X-ClientSecret': ApiConfig.clientSecret,
}

// All request will wait 1 min before timeout
axiosClient.defaults.timeout = 60000

// axiosClient.defaults.withCredentials = true;

export default axiosClient
